import { useId } from "react";
import { Icon } from "./Icon.jsx";

export function DetectionTooltip({ label, meaning, detection, opportunity, caution, align = "left" }) {
  const tooltipId = useId();
  const title = label || "Opportunity details";
  const help = meaning || opportunity || detection || caution;

  return (
    <span className={`detection-tooltip align-${align}`}>
      <button
        className="detection-tooltip-trigger"
        type="button"
        aria-label={`About ${title}`}
        aria-describedby={tooltipId}
      >
        <Icon name="info" size={14} strokeWidth={2} />
      </button>
      <span className="detection-tooltip-content" id={tooltipId} role="tooltip">
        <strong>{title}</strong>
        <span>{help}</span>
      </span>
    </span>
  );
}
